export default __webpack_public_path__ + "static/media/icon_date_range_green.334b688f.svg";